// @flow

import React, { type Node } from 'react';
import { getCustomerEmail, useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import styled from 'styled-components';

export function MailWarning(): Node {
  return (
    <Root>
      <MailMessage />
    </Root>
  );
}

function MailMessage(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'br':
      return(
        <>
          Uma cópia já foi enviada para <strong>{getCustomerEmail(incomingPayment)}</strong>,
          mas se preferir você pode pagar usando as informações abaixo
        </>
      );

    case 'ar':
    case 'bo':
    case 'cl':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
      return(
        <>
          Una cópia ya fue enviada para <strong>{getCustomerEmail(incomingPayment)}</strong>,
          sin embargo, ya puedes pagar tu compra con los seguientes datos:
        </>
      );

    default:
      throw new Error(`Mail warning: country ${country} is not supported`);
  }
}

const Root = styled.p`
  text-align: left;
  margin-bottom: 16px;
  font-weight: 400;
`;
